import { SxProps, Theme } from '@mui/material/styles'

/**
 * Global DataGrid styles to be applied via sx prop
 * MUI X DataGrid cannot be configured via theme.components since it's a separate package
 */
export const dataGridStyles: SxProps<Theme> = {
  '& .MuiDataGrid-columnHeader': {
    backgroundColor: '#047448',
    color: '#FFFFFF',
  },
  '& .MuiDataGrid-columnHeader .MuiIconButton-root': {
    color: '#FFFFFF',
  },
  '& .MuiDataGrid-columnHeader .MuiIconButton-root:hover': {
    color: '#FFFFFF',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
  },
  '& .MuiDataGrid-sortIcon': {
    color: '#FFFFFF',
  },
  '& .MuiDataGrid-menuIcon': {
    color: '#FFFFFF',
  },
  '& .MuiDataGrid-iconSeparator': {
    color: '#FFFFFF',
  },
  '& .MuiDataGrid-columnSeparator': {
    display: 'none',
  },
  '& .MuiDataGrid-cell:focus-within': {
    outline: 'none',
  },
  '& .MuiDataGrid-columnHeader:focus-within': {
    outline: 'none',
  },
  '& .MuiDataGrid-topContainer': {
    borderTop: '1px solid var(--DataGrid-rowBorderColor)',
  },
  '& a': {
    color: '#1AA85D',
  },
}
